<template>
  <div
    ref="scrollableContainer"
    class="flex-1 overflow-y-auto flex flex-col min-h-0"
  >
    <div class="overflow-x-auto">
      <table class="w-full border-separate border-spacing-0 text-xs">
        <thead>
          <tr class="bg-gray-50 border-b border-gray-200 sticky top-0 z-10">
            <th class="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider w-60">
              <div class="flex items-center gap-1">
                <span>
                  {{ $t('Subcontract.PackagesDashboard.PackageBreakdown.table.tradeItem') }}
                </span>

                <button
                  type="button"
                  class="btn btn--secondary-blue flex items-center gap-1 btn--small"
                  @click="$emit('table-mode-changed', tableMode === 'full' ? 'compact' : 'full')"
                >
                  <span>
                    {{ tableMode === 'full' ? 'Compact' : 'Full' }}
                  </span>

                  <svg fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" v-if="tableMode === 'full'"
                   
                    class="w-4 h-4">
    <path stroke-linecap="round" stroke-linejoin="round" d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5" />
  </svg>

                  <svg fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" v-else
                   
                    class="w-4 h-4">
    <path stroke-linecap="round" stroke-linejoin="round" d="M3 4.5h14.25M3 9h9.75M3 13.5h9.75m4.5-4.5v12m0 0-3.75-3.75M17.25 21 21 17.25" />
  </svg>
                </button>
              </div>
            </th>

            <th class="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              WBS Code
            </th>

            <th class="px-4 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">
              {{ $t('Subcontract.PackagesDashboard.PackageBreakdown.table.tenderQuantity') }}
            </th>

            <th class="px-4 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">
              {{ $t('Subcontract.PackagesDashboard.PackageBreakdown.table.tenderRate') }}
            </th>

            <th class="px-4 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">
              {{ $t('Subcontract.PackagesDashboard.PackageBreakdown.table.budget') }}
            </th>

            <th class="px-4 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">
              Awarded Works
            </th>

            <th class="px-4 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">
              {{ $t('Subcontract.PackagesDashboard.PackageBreakdown.table.awardedQuantity') }}
            </th>

            <th class="px-4 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">
              {{ $t('Subcontract.PackagesDashboard.PackageBreakdown.table.awardedRate') }}
            </th>

            <th class="px-4 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">
              {{ $t('Subcontract.PackagesDashboard.PackageBreakdown.table.awardedValue') }}
            </th>

            <th class="px-4 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">
              {{ $t('Subcontract.PackagesDashboard.PackageBreakdown.table.margin') }}
            </th>
          </tr>
        </thead>

        <tbody class="bg-white divide-y divide-gray-200 text-xs">
          <template
            v-for="[tradeId, trade] in packageTradeItemsByTrade"
            :key="tradeId"
          >
            <tr
              v-if="trade.trade"
              class="bg-blue-50 border-b-2 border-blue-200"
            >
              <td
                class="px-4 py-3 font-semibold text-blue-900 text-sm"
                colspan="10"
              >
                {{ trade.trade.name }}
              </td>
            </tr>

            <PackageTradeItemRow
              v-for="item in trade.items"
              :key="item.tradeItem.id"
              :trade-item="item.tradeItem"
              :show-edit-buttons="showEditButtons"
              :package="selectedPackage"
              :scrollable-container="scrollableContainer"
              @delete="$emit('delete', $event)"
            />
          </template>

          <template
            v-for="[tradeId, trade] in selectedTradeItemsByTrade"
            :key="tradeId"
          >
            <tr
              v-if="trade.trade"
              class="bg-green-50 border-b-2 border-green-200"
            >
              <td
                class="px-4 py-3 font-semibold text-green-900 text-sm"
                colspan="10"
              >
                {{ trade.trade.name }} (New)
              </td>
            </tr>

            <PackageTradeItemFormRow
              v-for="selectedTradeItem in trade.items"
              :key="selectedTradeItem.id"
              :ref="(el) => {
                if (el) formRows.set(selectedTradeItem.id, el as any)
              }"
              :selected-trade-item="selectedTradeItem"
              :selected-package="selectedPackage"
              :scrollable-container="scrollableContainer"
              @package-trade-item-created="$emit('package-trade-item-created', { tradeItem: selectedTradeItem, addedVia: $event.addedVia })"
              @package-trade-item-removed="$emit('package-trade-item-removed', selectedTradeItem)"
            />
          </template>

          <!-- Empty State -->
          <tr v-if="packageTradeItems.length === 0 && selectedTradeItems.length === 0">
            <td
              colspan="10"
              class="px-6 py-12 text-center"
            >
              <div class="flex flex-col items-center">
                <div class="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mb-4">
                  <svg
    viewBox="0 0 24 24"
    fill="none"
 class="w-8 h-8 text-gray-400">
    <path
        d="M8 5.00005C7.01165 5.00082 6.49359 5.01338 6.09202 5.21799C5.71569 5.40973 5.40973 5.71569 5.21799 6.09202C5 6.51984 5 7.07989 5 8.2V17.8C5 18.9201 5 19.4802 5.21799 19.908C5.40973 20.2843 5.71569 20.5903 6.09202 20.782C6.51984 21 7.07989 21 8.2 21H15.8C16.9201 21 17.4802 21 17.908 20.782C18.2843 20.5903 18.5903 20.2843 18.782 19.908C19 19.4802 19 18.9201 19 17.8V8.2C19 7.07989 19 6.51984 18.782 6.09202C18.5903 5.71569 18.2843 5.40973 17.908 5.21799C17.5064 5.01338 16.9884 5.00082 16 5.00005M8 5.00005V7H16V5.00005M8 5.00005V4.70711C8 4.25435 8.17986 3.82014 8.5 3.5C8.82014 3.17986 9.25435 3 9.70711 3H14.2929C14.7456 3 15.1799 3.17986 15.5 3.5C15.8201 3.82014 16 4.25435 16 4.70711V5.00005"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
    />
</svg>
                </div>

                <h3 class="text-lg font-medium text-gray-900 mb-2">
                  {{ $t('Subcontract.PackagesDashboard.PackageBreakdown.table.noTradeItemsAssigned') }}
                </h3>

                <p class="text-gray-500 mb-4">
                  Add trade items to this package to get started.
                </p>
              </div>
            </td>
          </tr>

          <!-- Totals Row -->
          <tr
            v-if="packageTradeItems.length > 0"
            class="bg-gray-50 border-t-2 border-gray-300 font-semibold text-sm"
          >
            <td class="px-4 py-3 text-gray-900">
              {{ $t('Subcontract.PackagesDashboard.PackageBreakdown.table.total') }}
            </td>

            <td class="px-4 py-3" />

            <td class="px-4 py-3" />

            <td class="px-4 py-3" />

            <td class="px-4 py-3 text-right text-gray-900">
              {{ $tcc(totalBudget) }}
            </td>

            <td class="px-4 py-3" />

            <td class="px-4 py-3" />

            <td class="px-4 py-3" />

            <td class="px-4 py-3 text-right text-gray-900">
              {{ $tcc(totalAwarded) }}
            </td>

            <td
              class="px-4 py-3 text-right"
              :class="[totalProfit < 0 ? 'text-red-600' : 'text-green-600']"
            >
              {{ $tcc(totalProfit) }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script setup lang="ts">
import Package from '@/models/Package';
import PackageTradeItem from '@/models/PackageTradeItem';
import Trade from '@/models/Trade';
import TradeItem from '@/models/TradeItem';
import { computed, ref, useTemplateRef } from 'vue';
import PackageTradeItemFormRow from './PackageTradeItemFormRow.vue';
import PackageTradeItemRow from './PackageTradeItemRow.vue';

const props = defineProps<{
  packageTradeItemsByTrade: Map<
    Id,
    { trade: Trade | undefined; items: { tradeItem: TradeItem; packageTradeItem: PackageTradeItem }[] }
  >;
  selectedTradeItemsByTrade: Map<Id, { trade: Trade; items: TradeItem[] }>;
  packageTradeItems: PackageTradeItem[];
  selectedTradeItems: TradeItem[];
  selectedPackage: Package;
  showEditButtons: boolean;
  totalBudget: number;
  totalAwarded: number;
  totalProfit: number;
  tableMode: 'full' | 'compact';
}>();

defineEmits<{
  (e: 'delete', packageTradeItem: PackageTradeItem): void;
  (e: 'package-trade-item-created', payload: { tradeItem: TradeItem; addedVia: 'rate' | 'value' }): void;
  (e: 'package-trade-item-removed', tradeItem: TradeItem): void;
  (e: 'table-mode-changed', mode: 'full' | 'compact'): void;
}>();

const scrollableContainer = useTemplateRef<HTMLDivElement>('scrollableContainer');
const formRows = new Map<Id, InstanceType<typeof PackageTradeItemFormRow>>();

function focusNextFormRow(selectedTradeItemId: Id, addedVia: 'rate' | 'value') {
  const row = formRows.get(selectedTradeItemId);

  if(row && typeof row.focusQuantity === 'function') {
    if(addedVia === 'rate') {
      row.focusQuantity();
    } else {
      row.focusValue();
    }
  }
}

defineExpose({
  focusNextFormRow,
});
</script>
